import React, { Component } from "react";
import { Switch, Route, Link, useHistory } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import * as FaIcons from "react-icons/fa";
import * as AiIcons from "react-icons/ai";
import * as IoIcons from "react-icons/io";
import * as BsIcons from "react-icons/bs";
import * as ImIcons from "react-icons/im";
import * as GoIcons from "react-icons/go";
import * as RiIcons from "react-icons/ri";
import AuthService from "./services/auth.service";

import Login from "./components/login.component";
import Register from "./components/register.component";
import Home from "./components/home.component";
import Profile from "./components/profile.component";

import EventBus from "./common/EventBus";
import Navbar from "./components/Navbar";
import BigCalendar from "./components/CalendarComp";
import { Users } from "./users/Index";
import { Cases } from "./cases/Index";
import { Agencies, Agents } from "./agencies/Index";
import { Contacts } from "./contacts/Index";
import { Markup } from "./markup/Index";
import { Attorneys } from "./attorneys/Index";
import { Firms } from "./firms/Index";
import Footer from "./components/Footer";
import { AddEditAtt } from "./attorneys/AddEditAtt";
import { ViewAtt } from "./attorneys/ViewAtt";
import agentMap, { List } from "./agencies/List";
import { AddEditAgent } from "./agencies/AddEditAgent";
import ProtectedRoute from "./PrivateRoute";
import map from "./attorneys/map";
import { AddEditFirm } from "./firms/AddEditFirm";
import { AddEdit } from "./contacts/AddEdit";
import { ViewContact } from "./contacts/ViewContact";

import { Requests } from "./requests/Index";
import { Reports } from "./reports/Index";
import { Deadline } from "./deadline/Index";
import { Courts } from "./courts/Index";
import { PieChart } from "./piechart/Index";

class App extends Component {
  constructor(props) {
    super(props);
    this.logOut = this.logOut.bind(this);

    this.state = {
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
    };
  }

  componentDidMount() {
    const user = AuthService.getCurrentUser();
    if (user) {
      this.setState({
        currentUser: user,
        showModeratorBoard: user.roles.includes("ROLE_MODERATOR"),
        showAdminBoard: user.roles.includes("ROLE_ADMIN"),
      });
    }

    EventBus.on("logout", () => {
      this.logOut();
    });
  }

  componentWillUnmount() {
    EventBus.remove("logout");
  }

  logOut() {
    AuthService.logout();
    this.setState({
      showModeratorBoard: false,
      showAdminBoard: false,
      currentUser: undefined,
    });
  }

  render() {
    const { currentUser, showModeratorBoard, showAdminBoard } = this.state;
    return (
      <div className="navbar-nav mr-auto">
        <div className="scrollbarRemove">
          {showModeratorBoard && console.log("is a mod")}
          {showAdminBoard && (
            //  <div id='buttonTwo'>
            //       <Link to={"/profile"} className="topbar-nav">
            //       <AiIcons.AiOutlineProfile size={42} />
            //       <span class="caption"> Profile</span>

            //     </Link>
            <div id="buttonThree">
              <Link to={"/users"} className="topbar-nav">
                <FaIcons.FaUsersCog size={42} />
                <span className="caption" style={{ fontWeight: "bold" }}>
                  {" "}
                  Users
                </span>
              </Link>
            </div>
            // </div>
          )}
          {currentUser && (
            <div>
              <div id="button"></div>
              <div id="buttonTwo">
                <Link to={"/profile"} className="topbar-nav">
                  <RiIcons.RiAccountBoxFill size={42} />
                  <span className="caption" style={{ fontWeight: "bold" }}>
                    {" "}
                    Profile
                  </span>
                </Link>
              </div>
              <div id="button">
                <a href="/login" onClick={this.logOut}>
                  <GoIcons.GoSignOut size={36} />
                  <span className="caption" style={{ fontWeight: "bold" }}>
                    {" "}
                    Log out
                  </span>
                </a>
              </div>
            </div>
          )}
        </div>
        {currentUser ? <Navbar /> : <div className="navbar-nav ml-auto"> </div>}

        <div className="container mt-3">
          <Switch>
            <ProtectedRoute exact path={["/", "/home"]} component={Home} />
            <Route exact path="/login" component={Login} />
            <Route exact path="/register" component={Register} />
            <ProtectedRoute exact path="/calendar" component={BigCalendar} />
            <ProtectedRoute exact path="/profile" component={Profile} />
            <Route path="/attorneys" component={Attorneys} />
            <Route path="/firms" component={Firms} />
            <Route path="/cases" component={Cases} />
            <Route path="/users" component={Users} />
            <Route path="/agencies" component={Agents} />
            <Route path="/contacts" component={Contacts} />
            <Route path="/markup" component={Markup} />
            <Route path="/courts" component={Courts} />
            <Route path="/requests" component={Requests} />
            <Route path="/reports" component={Reports} />
            <Route path="/deadline" component={Deadline} />
            <Route path="/summary" component={PieChart} />
          </Switch>
        </div>
      </div>
    );
  }
}

export default App;
